<template>
    <div class="card">
        <div class="card-header">
            <div class="col-md-12">
                <h4>
                    <i class="fa fa-edit"></i>
                    {{'Edit Job'|trans}}
                    <RouterLink :to="{name:'job_list'}" class="pull-right btn-default btn">
                        <i class="icon fa fa-plus-circle">️&zwnj;</i>
                        <span class="title">{{ 'Job List' | trans }}</span>
                    </RouterLink>
                </h4>
            </div>
        </div>
        <div class="row card-body " id="edit-job-form" v-if="isUpdatingJob">
            <div class="alert alert-success text-center" >
                <strong>{{'Your job has been updated'|trans}}</strong>
            </div>
        </div>

        <spinner v-if="isGettingJob"></spinner>

        <div class="row card-body " id="edit-job-form" v-if="!isUpdatingJob && !isGettingJob">

            <div  class="col-md-12 col-sm-12 col-xs-12 ">
                <textarea v-model="job.description" class="form form-control"> </textarea>
            </div>

            <div  class="col-md-12 col-sm-12 col-xs-12 ">
                <label for="time-required-for-job">
                    <span class="fa fa-clock-o"></span>
                    {{'Time Required'|trans}}
                </label>
                <br>
                <div class="btn-group " role="group" id="time-required-for-job">
                    <button v-for="time in timeRequiredForJob"
                            @click="job.timeRequired=time.value"
                            :class="{'selected': job.timeRequired === time.value}"
                            type="button" class="btn btn-default">
                        {{time.label}}
                    </button>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 " >
                <label>{{'Suggestions'|trans}}</label>
                <SlotSuggestions v-bind:dataQuery="dataQuery" v-on:slotSelected="formatDateFromSlotSuggestion($event)"></SlotSuggestions>
            </div>

            <div  class="col-md-12 col-sm-12 col-xs-12 ">
                <button class="btn btn-primary" @click="submitJobForUpdate">{{'Update'|trans}}</button>
            </div>

        </div>
    </div>
</template>

<script>
	import JobForm from "./JobForm";
	import Spinner from "../Spinner";
	import SlotSuggestions from "../SlotSuggestions/SlotSuggestions";
	export default {
		components: {SlotSuggestions, Spinner, JobForm},
		props: {
			user: Object
		},
		data: function () {
			return {
				timeRequiredForJob: [
					{'label': '40min', 'value': 40},
					{'label': '1h00', 'value': 60},
					{'label': '1h20', 'value': 80},
					{'label': '2h00', 'value': 120},
					{'label': '3h00', 'value': 180},
					{'label': '6h00', 'value': 360},
					{'label': '9h00', 'value': 540},
					{'label': '+', 'value': 0},
				],
				isGettingJob: true,
				isUpdatingJob: false,
				job: {
					interventionType:'',
					id:null,
					dateJobStart:null,
					description: null,
					timeRequired: null,
					jobTypeId: null,
					customer: {
						lastName: '',
						language: '',
						email: '',
						phone : ''
					},
					address: {
						zoneId: null,
						street: null,
						number: null,
					},
				}
			};
		},
        created() {
			this.getJob(this.$route.params.jobId);
		},
        methods:{
			async getJob(jobId){
				this.job = await this.$api.job.getJob(jobId);
				this.isGettingJob = false;
            },
			async submitJobForUpdate() {
				this.isUpdatingJob = true;
				try {
					this.job.action = "edit";
					console.log(this.job);
					let responseJobAdded = await this.$api.job.updateJobAsWorkerOwner(this.job);
				}
				catch (error) {
					if (this.$api.is401(error)) {
						// in case of 401, just abort javascript execution
						return;
					}
					if (this.$api.isCancel(error)) {
						// request canceled programmatically, let the new request do the job
						return;
					}
					if (this.$api.isNoConnectivity(error)) {
						this.errorMessage = this.$options.filters.trans('No connection ?');
					} else {
						this.$bugsnagClient.notify(error);
						this.errorMessage = this.$options.filters.trans('Unknown error');
					}
				}
			},
            formatDateFromSlotSuggestion(date){
				// This is a hack
				this.job.dateJobStart = this.$moment.unix(date).format('Y-MM-DD H:mm');
            }
        },
		computed:{
			dataQuery(){
				return {
					interventionAddressZoneId : this.job.address.zoneId,
					leafJobTypeId : this.job.jobTypeId,
					restrictToWorkerId : this.user.user_id,
					durationRequired : this.job.timeRequired,
					interventionType :"'new'"
				}
			}
        },
        filters:{

        }
	}
</script>

